'use client'; // Necesario para los componentes de cliente en Next.js

import React, { useState, useEffect } from 'react';

const Modal = () => {
  const [isOpen, setIsOpen] = useState(true);

  // Función para cerrar el modal
  const closeModal = () => {
    setIsOpen(false);
  };

  // Cerrar el modal cuando se hace clic fuera de él
  const handleOutsideClick = (e) => {
    if (e.target.classList.contains('modal-overlay')) {
      closeModal();
    }
  };

  // Efecto para que el modal se abra al cargar la página
  useEffect(() => {
    setIsOpen(true);
  }, []);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleOutsideClick} style={styles.overlay}>
      <div className="modal-content" style={styles.modal}>
        <button onClick={closeModal} style={styles.closeButton}>
          X
        </button>
        <img
          src="https://storage.googleapis.com/roslindale/Roslindale_website_flyer.png"
          alt="Promotional Flyer"
          style={styles.image}
        />
      </div>
    </div>
  );
};

// Estilos en línea
const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  },
  modal: {
    width: 'auto',
    maxWidth: '560px', // Ancho máximo del modal
    maxHeight: '90vh',
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '0',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    position: 'relative', // Para posicionar el botón de cierre
  },
  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    borderRadius: '50%',
    border: 'none',
    fontSize: '20px',
    cursor: 'pointer',
    width: '30px',
    height: '30px',
    lineHeight: '30px',
    textAlign: 'center',
    zIndex: 10, // Para que el botón esté por encima de la imagen
  },
  image: {
    width: '100%',
    height: 'auto',
    borderRadius: '8px',
    display: 'block', // Para evitar espacios extra
  },
};


export default Modal;
